import { Box, Flex, styled, StyleSystemProps } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { pxToRem } from '@withjoy/joykit/theme';

// Base styled components
export const StyledWrapper = styled(Box)``;
export const StyledMediaContainer = styled(Box)``;
export const StyledMediaContent = styled(Box)``;
export const StyledMediaBackgroundImage = styled(Box)``;

export const StyledTextContainer = styled(Box)``;
export const StyledTextContent = styled(Flex)``;
export const StyledTextHed = styled(Box)``;
export const StyledTextSubtitle = styled(Box)``;

/* Wrapper Styles */
const wrapperStyles: StyleSystemProps = {
  width: '100%',
  position: 'relative',
  marginBottom: 8
};

/* Media Container Styles */
const mediaContainerStyles: StyleSystemProps = {
  width: '100%',
  height: {
    _: `160px`,
    sm: `calc(49vh - var(--mobile-public-shop-navbar-height, 0px) - var(--mobile-admin-shop-navbar-height, 0px))`
  },
  zIndex: 0,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-end',
  backgroundColor: 'black'
};

/* Media Content Styles */
const mediaContentStyles: StyleSystemProps = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  right: '0px',
  zIndex: 0,
  height: '100%'
};

const mediaLayerStyles: StyleSystemProps = {
  ...mediaContentStyles,
  height: '100%',
  width: '100%'
};

/* Media Background Image Styles */
const mediaBackgroundImageStyles = (backgroundImageUrl: Maybe<string>, disableBackgroundGradient: boolean): StyleSystemProps => ({
  ...mediaLayerStyles,
  zIndex: 3,
  background: !disableBackgroundGradient
    ? `linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), url(${backgroundImageUrl}), lightgray 50% / cover no-repeat`
    : undefined,
  backgroundPosition: 'center',
  backgroundSize: 'cover'
});

const alignmentConfig: Record<string, StyleSystemProps> = {
  left: { alignItems: 'flex-start', textAlign: 'start' },
  center: { alignItems: 'center', textAlign: 'center' },
  right: { alignItems: 'flex-end', textAlign: 'end' }
};

/* Text Container Styles */
const textContainerStyles: StyleSystemProps = {
  height: {
    _: 'auto',
    sm: '100%'
  },
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  zIndex: 1,
  paddingX: {
    _: 3,
    sm: 10,
    md: pxToRem(120)
  },
  paddingY: {
    _: 8,
    sm: 0
  },
  position: {
    sm: 'absolute'
  },
  left: {
    sm: '50%'
  },
  top: {
    sm: '50%'
  },
  transform: {
    sm: 'translate(-50%, -50%)'
  },
  ...alignmentConfig['center']
};

/* Text Content Styles */
const textContentStyles: StyleSystemProps = {
  ...alignmentConfig['center'],
  flexDirection: 'column',
  zIndex: 3,
  color: 'white',
  marginX: [6, null, 3],
  maxWidth: '100%'
};

/* Text Head Styles */
const textHedStyles: StyleSystemProps = {
  typographyVariant: {
    _: 'hed6',
    sm: 'display3'
  },
  color: {
    _: 'mono14',
    sm: 'white'
  },
  transition: animationTransition('color'),
  maxWidth: pxToRem(995),
  marginX: 6,
  marginBottom: 5,
  width: '100%',
  whiteSpace: 'break-spaces'
};

/* Text SubTitle Styles */
const textSubTitleStyles: StyleSystemProps = {
  fontSize: {
    _: 17,
    sm: 26
  },
  color: {
    _: 'mono14',
    sm: 'white'
  },
  maxWidth: {
    _: pxToRem(238),
    sm: pxToRem(600)
  },
  lineHeight: '130%'
};

export const styles = {
  wrapper: wrapperStyles,
  mediaContent: mediaContentStyles,
  mediaContainer: mediaContainerStyles,
  mediaBackgroundImage: mediaBackgroundImageStyles,
  textContainer: textContainerStyles,
  textContent: textContentStyles,
  textHed: textHedStyles,
  textSubTitle: textSubTitleStyles
};
